import { create } from "zustand";
import { Application } from '../types';

export interface WorkflowsState {
    workflows: Application[];
    setWorkflows: (workflows: Application[]) => void;
    apiStatus: string;//"error" | "idle" | "loading" | "success"
    setApiStatus: (apiStatus: string) => void;
    isFetched: boolean;
    setIsFetched: (isFetched: boolean) => void;
}

export const useAllWorkflowsStore = create<WorkflowsState>((set) => ({
    workflows: [],
    setWorkflows: (workflows) => set(() => ({ workflows })),
    apiStatus: "",
    setApiStatus: (apiStatus) => set(() => ({ apiStatus })),
    isFetched: false,
    setIsFetched: (isFetched) => set(() => ({ isFetched }))
}));
